
import { ObjectsParams } from '../../types/ParamsTypes';
import { StepperOperator } from "../../components/common/Stepper/Stepper";

export const getUpdatedObjectFilterBedroomsParams = (
  objectsPara: ObjectsParams,
  value: number,
  operator: StepperOperator,
): ObjectsParams => {
  let updatedValue = value;

  if (operator === StepperOperator.INCREMENT) {
    updatedValue = updatedValue + 1;
  }

  if (operator === StepperOperator.DECREMENT && updatedValue > 0) {
    updatedValue = updatedValue - 1;
  }

  return { ...objectsPara, numberOfBedrooms: updatedValue };
};
